import { useEffect } from 'react';

import { BrandTile } from '@/components/BrandTile';
import { announceSignedIn } from '@/features/session/signedInSignal';

import CheckIcon from '@mui/icons-material/Check';
import { Button, Sheet, Stack, Typography } from '@mui/joy';

/**
 * `/auth/done` — the end of the sign-in window (ADR-0004 §2.4): tells the panel and closes. Outside the session gate:
 * it is the window itself. A window the script did not open stays, hence the text and the button.
 */
export const AuthDonePage = () => {
  useEffect(() => {
    announceSignedIn();
    window.close();
  }, []);

  return (
    <Stack alignItems='center' sx={{ height: '100dvh', p: 3 }}>
      <Stack direction='row' alignItems='center' gap={1}>
        <BrandTile size={28} />
        <Typography level='title-md'>Gasbi AI</Typography>
      </Stack>
      <Stack
        alignItems='center'
        justifyContent='center'
        gap={1}
        sx={{ flex: 1, textAlign: 'center' }}
      >
        <Sheet
          variant='soft'
          color='success'
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 40,
            mb: 2,
          }}
        >
          <CheckIcon fontSize='inherit' />
        </Sheet>
        <Typography level='h3'>Вхід виконано</Typography>
        <Typography level='body-md' textColor='neutral.600'>
          Це вікно можна закрити.
        </Typography>
        <Typography
          level='body-sm'
          textColor='neutral.500'
          sx={{ maxWidth: 360 }}
        >
          Чат «Gasbi AI» уже працює під вашим обліковим записом.
        </Typography>
        <Button
          variant='outlined'
          color='neutral'
          onClick={() => window.close()}
          sx={{ mt: 2 }}
        >
          Закрити вікно
        </Button>
      </Stack>
    </Stack>
  );
};
